import { defineComponent as _defineComponent } from 'vue'
import { BendingProductivityData } from '@/models/Charts/chartsData';
import KpiWidget from '../common/KpiWidget.vue';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { useI18n } from '@/composables/i18n';
import { computed } from 'vue';
import { TrendData } from './kpiWidgetUtils';
import { formatPercentage } from '@/utils/number';
import { isNil } from '@/utils/misc';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendProductivityKpiWidget',
  props: {
    data: null,
    generator: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: BendingProductivityData | null;
  generator: ChartGenerator<BendingProductivityData>;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  isFetchingForTheFirstTime: boolean;
};



const trendData = computed<TrendData | null>(() => {
  if (isNil(props.data)) {
    return null;
  }

  return {
    currentValue:
      props.data?.totalBendTimes.currentAvailableHours !== 0
        ? (props.data.totalBendTimes.currentTotalHours /
            props.data?.totalBendTimes.currentAvailableHours) *
          100
        : 0,
    previousValue:
      props.data?.totalBendTimes.previousAvailableHours !== 0
        ? (props.data.totalBendTimes.previousTotalHours /
            props.data?.totalBendTimes.previousAvailableHours) *
          100
        : 0,
    chartType: 'pie',
    timeSpan: props.widgetDefinition.timeFilterEnumValue!,
  };
});

const { t } = useI18n();

return { __sfc: true,props, trendData, t, KpiWidget, formatPercentage }
}

})